// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'disc-nodes';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.031 5.282c0 .564.448 1.104 1.245 1.503.797.398 1.878.622 3.005.622s2.208-.224 3.005-.622c.797-.399 1.245-.94 1.245-1.503 0-.564-.448-1.104-1.245-1.503-.797-.398-1.878-.622-3.005-.622s-2.208.224-3.005.622c-.797.399-1.245.94-1.245 1.503z' />
    <path d='M1.031 5.282v3.187c0 1.174 1.903 2.126 4.25 2.126s4.25-.952 4.25-2.126V5.282' />
    <path d='M1.031 8.47v3.187c0 1.174 1.903 2.125 4.25 2.125s4.25-.951 4.25-2.125V8.469m2.125-3.187L9.531 7.407m2.125-4.781c0 .422.28.828.778 1.127.498.299 1.174.466 1.879.466s1.38-.167 1.878-.466c.498-.3.778-.705.778-1.127s-.28-.828-.778-1.127c-.498-.3-1.174-.467-1.878-.467s-1.38.168-1.879.467c-.498.299-.778.704-.778 1.127z' />
    <path d='M11.656 2.625v3.188c0 .88 1.19 1.593 2.656 1.593s2.657-.714 2.657-1.593V2.624M9.242 12.43l2.414 2.414m0-2.656c0 .423.28.828.778 1.127.498.3 1.174.467 1.879.467s1.38-.168 1.878-.467c.498-.299.778-.704.778-1.127s-.28-.828-.778-1.127c-.498-.299-1.174-.467-1.878-.467s-1.38.168-1.879.467c-.498.3-.778.704-.778 1.127z' />
    <path d='M11.656 12.188v3.187c0 .88 1.19 1.594 2.656 1.594s2.657-.714 2.657-1.594v-3.187' />
  </g>
);

export const viewBox = '0 0 18 18';
